export default (el) => ({
  id: String(el.SplitDestinationID),
  name: String(el.SplitDestinationName),
  value: String(el.AmountDebt),
  amount: Number(el.AmountDebt),
});

export const backAdapter = (el) => ({
  SplitDestinationId: String(el.id),
  Amount: String(el.value),
  AmountToPay: String(el.amount),
});
